import { ToTopWidget } from '@website-builder/widgets/to-top/to-top-widget';
import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';
import { WebsiteTheme } from '@website-builder/model/domain/website-theme';
import { WidgetNormalizer } from '@website-builder/widgets/normalizer/widget-normalizer';

export class WebsiteConfiguration {
  toTop = new ToTopWidget();
  colors = [];
  fonts = [];
  textSize = 100;
  theme = WebsiteConfiguration.#createDefaultTheme();
  buttonGlobalStyles = new GlobalButtonStyle();
  domain = 'mexico-adventures.com';
  favicon = '';

  static normalize(config?: Partial<WebsiteConfiguration>): WebsiteConfiguration {
    const pureConfig = new WebsiteConfiguration();

    pureConfig.toTop = config?.toTop
      ? (WidgetNormalizer.normalizeInPlace(config.toTop as ToTopWidget) as ToTopWidget)
      : pureConfig.toTop;

    pureConfig.colors = config?.colors?.map(color => ({ ...color })) ?? pureConfig.colors;
    pureConfig.fonts = config?.fonts?.map(font => ({ ...font })) ?? pureConfig.fonts;
    pureConfig.textSize = config?.textSize ?? pureConfig.textSize;
    pureConfig.theme = { ...pureConfig.theme, ...(config?.theme ?? {}) };
    pureConfig.buttonGlobalStyles = GlobalButtonStyle.normalize(config?.buttonGlobalStyles);
    pureConfig.domain = config?.domain ?? pureConfig.domain;
    pureConfig.favicon = config?.favicon ?? pureConfig.favicon;

    return pureConfig;
  }

  static #createDefaultTheme(): WebsiteTheme {
    return {
      name: 'light',
      type: 'light',
    };
  }
}
